export default __webpack_public_path__ + "static/media/ecg_new.64e9e7ab.gif";